/**********************************| Document Ready Start |****************************/
$(document).ready(function () {
  product_offer_slider();
  ftr_top_sevices();  
  slide_sec_banner();

  /*--------------| FAQ Accordian start |------------------------*/ 
  $('.FAQQues').click(function() {
    if ($(this).hasClass('accoMinus')) {
      $(this).next().slideUp();
      $(this).removeClass('accoMinus');
      $(this).parent().removeClass('open-box');
    } else {
      $('.FAQQues').removeClass('accoMinus');
      $(this).addClass('accoMinus');
      $('.FAQAns').removeClass('open-box');
      $(this).parent().addClass('open-box');
      $('.FAQAns').slideUp();
      $(this).next().slideDown();      
    }
  });
  /*--------------| FAQ Accordian end |------------------------*/ 

  
});


function product_offer_slider(){
  if($.fn.slick){
     if(!$('.prd-banner-main.with-slider').hasClass('slick-initialized')){
      $('.prd-banner-main.with-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        variableWidth: true,
        draggable: true,
        dots: false,
        arrows:true,
        responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
            dots: false,
            arrows:true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
            dots: false,
            arrows:true
          }
        }
        ]
      });
    }
  }
}



function ftr_top_sevices(){
  if($.fn.slick){
     if(!$('.ftr-top-sevices').hasClass('slick-initialized')){
      $('.ftr-top-sevices').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        variableWidth: true,
        draggable: true,
        dots: false,
        arrows:true,
        responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"
        },  
        {
          breakpoint: 571,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
            dots: false,
            arrows:true
          }
        }
        ]
      });
    }
  }
}



function slide_sec_banner(){
  if($.fn.slick){
     if(!$('.slide_sec_banner').hasClass('slick-initialized')){
      $('.slide_sec_banner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        variableWidth: true,
        draggable: true,
        dots: false,
        arrows:true 
      });
    }
  }
}
